import { CommonModule, DatePipe } from '@angular/common';
import {
	ChangeDetectorRef,
	Component,
	Input,
	OnInit,
	Pipe,
	PipeTransform,
	ViewChild
} from '@angular/core';
import {
	AbstractControl,
	FormArray,
	FormBuilder,
	FormControl,
	FormGroup,
	FormsModule,
	ReactiveFormsModule,
	ValidationErrors,
	ValidatorFn,
	Validators
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import {
	BsDatepickerConfig,
	BsDatepickerDirective,
	BsDatepickerModule
} from 'ngx-bootstrap/datepicker';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TypeaheadMatch, TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { Observable, catchError, forkJoin, of, tap } from 'rxjs';
import {
	FORMATION_DURATION_MAX,
	MISSION_TYPE_PRESCRIPTION,
	MISSION_TYPE_QUALIFICATION_DEMAND,
	MISSION_TYPE_REUNION_TYPE
} from 'src/app/core/services/constant/constants.service';
import { DataStorageService } from 'src/app/core/services/dataStorage/data-storage.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { CompetencesElementaires } from 'src/app/shared/enums/competence.enum';
import { MissionTypeName } from 'src/app/shared/enums/mission-type-name.enum';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import { Employee } from 'src/app/shared/models/employee/employee';
import { MissionType } from 'src/app/shared/models/mission/mission-type';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import {
	durationValidator,
	workingTimeValidator
} from '../formations-modal-ajout-form/formations-modal-ajout-form.component';
import { MissionPlace } from 'src/app/shared/models/mission/mission-place';
import { OrderByPipe } from 'src/app/shared/pipes/order-by/order-by.pipe';
import { CareSkill } from 'src/app/shared/models/employee/care-skill';
import { ListAvailableEmployeesComponent } from '../../list-available-employees/list-available-employees.component';
import { Mission } from 'src/app/shared/models/mission/mission';
import { MissionRequest } from 'src/app/shared/models/mission/mission-request';
import { Specialite } from 'src/app/shared/models/specialite';
import { CenterDepartment } from 'src/app/shared/models/center-department';

@Pipe({
	name: 'competenceName',
	standalone: true
})
export class CompetenceNamePipe implements PipeTransform {
	transform(competence: CareSkill): string {
		return competence.name;
	}
}

@Component({
	selector: 'app-serie-modal-ajout-form',
	standalone: true,
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		BsDatepickerModule,
		TimepickerModule,
		TypeaheadModule,
		AccordionModule,
		ListAvailableEmployeesComponent,
		DatePipe,
		OrderByPipe,
		CompetenceNamePipe
	],
	templateUrl: './serie-modal-ajout-form.component.html',
	styleUrl: './serie-modal-ajout-form.component.scss'
})
export class SerieModalAjoutFormComponent implements OnInit {
	form!: FormGroup;

	bsInlineValue = new Date();
	bsInlineRangeValue: Date[];
	maxDate = new Date();

	bsConfig?: Partial<BsDatepickerConfig>;

	formattedDateRange: string = ''; // Pour stocker la plage de dates formatée
	requiredHours?: Date; // Pour stocker l'heure de début
	readyTimeDate = new Date(new Date().setHours(9, 0, 0, 0));
	dueTimeDate = new Date(new Date().setHours(10, 0, 0, 0));
	MIN_WORKING_HOUR = this.facade.dataStorageService.getParamMinDay();
	minWorkingHourAsDate = new Date(
		new Date().setHours(this.MIN_WORKING_HOUR, 0, 0, 0)
	);
	MAX_WORKING_HOUR = this.facade.dataStorageService.getParamMaxDay();
	maxWorkingHourAsDate = new Date(
		new Date().setHours(this.MAX_WORKING_HOUR, 0, 0, 0)
	);
	MAX_DURATION = Math.floor(FORMATION_DURATION_MAX / 60) || 0;
	minDurationAsDate = new Date(new Date().setHours(0, 0, 0, 0));

	selectedBeneficiaire: Beneficiaire;
	selectedMissionType: MissionType;
	selectedEmployeesForMission: Employee[] = [];
	selectedSpecialtiesForMission: Specialite[] = [];
	selectedEmployee: Employee;

	isReunion: boolean;
	isAPrescription: boolean = false;
	messageInviteIntervenantParticipant = 'Entrez un intervenant à ajouter';
	numberOfIntervenantsSelected = 1;
	maxIntervenantSelectableForMission;

	listMissionType: MissionType[];
	listBeneficiaire: Beneficiaire[];
	listBeneficiaireMapped = []; // list pour le typeahead sous forme {name:nom_beneficiaire,object:beneficiaire}
	listMissionPlace: MissionPlace[];
	listCompetences;
	listCareSpecialty: Specialite[];

	isProfessionnelSAE: boolean;
	isProjectManager: boolean;
	isProfessionnelTerrain: boolean;
	isSAE: boolean;

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	// Nouveaux champs
	numberOfPrestations = 1; // Valeur par défaut

	centerDepartments: CenterDepartment[];
	selectedCenterDepartment: CenterDepartment = null;

	isLoading = false;

	// Parameters SAE OCASHE
	@Input() parameters: {
		start: Date;
		end: Date;
		hours: number;
		prestationCount?: number;
		missionType: string;
		beneficiaireId?: number;
		idDemandDH?: string;
		serviceName?: string;
		intervenantId?: number;
	};

	constructor(
		private fb: FormBuilder,
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private logger: LogService,
		private dataStorageService: DataStorageService,
		private router: Router,
		private dateUtils: DateUtils,
		private bsModalService: BsModalService,
		private datePipe: DatePipe,
		private cdr: ChangeDetectorRef
	) {}

	ngOnInit() {
		this.isLoading = true;
		this.bsConfig = {
			containerClass: 'theme-dark-blue',
			dateCustomClasses: this.getDateCustomClasses()
		};

		this.isProfessionnelSAE =
			this.facade.dataStorageService.isProfessionnelSAE();
		this.isProfessionnelTerrain =
			this.facade.dataStorageService.isProfessionnelTerrain();
		this.isProjectManager = this.facade.dataStorageService.isProjectManager();
		this.isSAE = this.facade.dataStorageService.isSAE();

		// Initialiser le FormGroup
		this.form = this.fb.group({
			missionType: ['', Validators.required],
			requiredHours: ['', Validators.required],
			numberOfPrestations: new FormControl([this.numberOfPrestations]),
			beneficiaire: ['', Validators.required],
			remind: new FormControl(true),
			prestations: this.fb.array(this.createPrestationsForm()),
			centerDepartment: new FormControl(null)
		});

		// Retries datas
		forkJoin({
			careSkills: this.facade.careSkillService.getAllCareSkills(),
			beneficiaires: this.facade.beneficiaireService.getBeneficiairesMinimal(),
			missionTypes: this.facade.missionTypeService.getAllMissionTypes(),
			missionPlaces: this.facade.missionPlaceService.getMissionPlaces(),
			specialties: this.facade.specialiteService.getAllSpecialites(),
			centerDepartments:
				this.facade.centerDepartmentService.getAllCenterDepartmentsForUserCenter()
		}).subscribe(
			({
				careSkills,
				beneficiaires,
				missionTypes,
				missionPlaces,
				specialties,
				centerDepartments
			}) => {
				this.listCompetences = careSkills;
				this.listBeneficiaire = beneficiaires;
				this.listBeneficiaireMapped = beneficiaires.flatMap((e) => {
					return { name: e.firstName + ' ' + e.lastName, object: e };
				});

				this.listMissionType = missionTypes;
				// Filter the list of mission types based on the user's role as a project manager
				if (this.facade.dataStorageService.isProjectManager()) {
					this.listMissionType = this.listMissionType.filter(
						(missionType) => missionType.type !== MISSION_TYPE_REUNION_TYPE
					);
				}
				this.listMissionPlace = missionPlaces;
				this.listCareSpecialty = specialties;
				this.centerDepartments = centerDepartments;
				if (this.parameters) {
					this.initFormWithParameters();
				} else {
					this.maxDate.setDate(this.maxDate.getDate() + 7);
					this.bsInlineRangeValue = [this.bsInlineValue, this.maxDate];
					this.updateBsConfig();
					this.isLoading = false;
				}
			}
		);
	}

	ngAfterViewChecked() {
		// Formater initialement la plage de dates
		this.updateFormattedDateRange();
		this.cdr.detectChanges(); // Assurer la détection des changements
	}

	createPrestationsForm() {
		return Array(this.numberOfPrestations)
			.fill(null)
			.map((_, index) =>
				this.fb.group(
					{
						date: [null, Validators.required],
						readyTime: new FormControl(this.readyTimeDate, [
							Validators.required,
							workingTimeValidator(this.MIN_WORKING_HOUR, this.MAX_WORKING_HOUR)
						]),
						dueTime: new FormControl(this.dueTimeDate, [
							Validators.required,
							workingTimeValidator(this.MIN_WORKING_HOUR, this.MAX_WORKING_HOUR)
						]),
						missionPlace: new FormControl(
							null,
							this.createMissionPlaceValidator(index)
						),
						missionPlaceName: new FormControl(''), // Champ pour le nom affiché
						isMissionPlaceBeneficiaireAddress: new FormControl(false),
						isRemote: new FormControl(false),
						competences: this.fb.array([] as CareSkill[]),
						specialty: [''],
						notes: new FormControl('', Validators.maxLength(1023))
					},
					{
						validators: [durationValidator(this.MAX_DURATION)]
					}
				)
			);
	}

	initFormWithParameters() {
		// Remplissage du formulaire avec les paramètres "simples"
		this.initFormStaticParameters();

		// Construction de la liste d'observables à appeler
		const apiCalls: Observable<any>[] = this.buildApiCalls();

		// Exécution centralisée des appels API
		if (apiCalls.length > 0) {
			forkJoin(apiCalls).subscribe({
				next: () => {
					this.isLoading = false;
				},
				error: (e) => {
					this.logger.error(e);
					this.isLoading = false;
				}
			});
		} else {
			this.isLoading = false;
		}
	}

	initFormStaticParameters() {
		if (this.parameters.start && this.parameters.end) {
			this.bsInlineRangeValue = [
				new Date(this.parameters.start),
				new Date(this.parameters.end)
			];
			this.updateBsConfig();
		}

		if (this.parameters.hours) {
			this.form
				.get('requiredHours')
				.setValue(
					this.dateUtils.getFullDateFromDateAndMinutes(
						new Date(this.parameters.start),
						this.parameters.hours * 60
					)
				);
			this.form.controls['requiredHours']['disable']({
				onlySelf: true,
				emitEvent: false
			});
		}

		if (this.parameters.prestationCount) {
			this.numberOfPrestations = this.parameters.prestationCount;
			this.setPrestations(this.numberOfPrestations);
		}

		if (this.parameters.missionType) {
			this.selectedMissionType = this.listMissionType.find(
				(type) => type.type === this.parameters.missionType
			);
			this.form.get('missionType').setValue(this.selectedMissionType.type);
			this.selectCareSkillFromMissionTypeSAE(-1);
			this.form.controls['missionType']['disable']({
				onlySelf: true,
				emitEvent: false
			});
		}

		if (this.parameters.serviceName) {
			const service = this.centerDepartments?.find(
				(e) => e.name === this.parameters.serviceName
			);
			this.form.get('centerDepartment').setValue(service.name);
			this.selectedCenterDepartment = service;
			this.form.controls['centerDepartment']['disable']({
				onlySelf: true,
				emitEvent: false
			});
		}
	}

	/**
	 * Construit la liste des appels API nécessaires
	 */
	private buildApiCalls(): any[] {
		const calls = [];

		if (this.parameters.beneficiaireId) {
			const call = this.facade.beneficiaireService
				.getBeneficiaireIdByOcasheId(this.parameters.beneficiaireId)
				.pipe(
					tap((beneficiaireId) => {
						this.selectedBeneficiaire = this.listBeneficiaire.find(
							(b) => b.id === beneficiaireId
						);
						const beneficiaireMapped = this.listBeneficiaireMapped.find(
							(e) => e.object.id === beneficiaireId
						);
						this.form.get('beneficiaire').setValue(beneficiaireMapped.name);
						this.form.controls['beneficiaire']['disable']({
							onlySelf: true,
							emitEvent: false
						});
					})
				);
			calls.push(call);
		}

		if (this.parameters.intervenantId) {
			const call = this.facade.employeeService
				.getEmployeeByOcasheId(this.parameters.intervenantId)
				.pipe(
					tap((employee) => {
						this.selectedEmployee = employee;
					})
				);
			calls.push(call);
		}

		return calls;
	}

	shouldSubmitButtonBeDisabled() {
		const isDateRangeSet = this.bsInlineRangeValue?.length === 2;
		const isRequiredHoursSet =
			this.form.get('requiredHours').value !== '' &&
			this.form.get('requiredHours').value > 0;
		const isNumberOfPrestationsSet =
			this.form.get('numberOfPrestations').value > 0;
		const isMissionTypeSet =
			this.form.get('missionType').value !== '' && this.selectedMissionType;
		const isBeneficiaireSet =
			this.form.get('beneficiaire').value !== '' && this.selectedBeneficiaire;

		const areGlobalParametersFilled =
			isDateRangeSet &&
			isRequiredHoursSet &&
			isNumberOfPrestationsSet &&
			isMissionTypeSet &&
			isBeneficiaireSet;

		let arePrestationsParametersFilled = true;
		this.form.get('prestations').value.forEach((p) => {
			const isAtLeastOneCompetenceSet = p.competences.length > 0;
			const isDateSet = !!p.date;
			const isReadyTimeSet = !!p.readyTime;
			const isDueTimeSet = !!p.dueTime;
			const isMissionPlaceSet = !!p.missionPlace;
			const isMissionPlaceAtBeneficiaireAddress =
				p.isMissionPlaceBeneficiaireAddress;
			const isRemote = p.isRemote;
			const isAPlaceSet =
				isMissionPlaceSet || isMissionPlaceAtBeneficiaireAddress || isRemote;
			if (
				!isAtLeastOneCompetenceSet ||
				!isDateSet ||
				!isReadyTimeSet ||
				!isDueTimeSet ||
				!isAPlaceSet
			) {
				arePrestationsParametersFilled = false;
			}
		});

		return !areGlobalParametersFilled || !arePrestationsParametersFilled;
	}

	onSubmit() {
		const listMission: Mission[] = this.prepareMissionList();
		if (!listMission.length) return;

		// Création de la liste des missions avec un employé assigné
		const listMissionWithAssignedEmployee: Mission[] = listMission.filter(
			(mission) => !!mission.assignedEmployee
		);

		// Création de la liste des missions sans employé assigné
		const listMissionWithoutAssignedEmployee: Mission[] = listMission.filter(
			(mission) => !mission.assignedEmployee
		);

		// Création d'un dictionnaire pour les observables
		let observables: { [key: string]: Observable<any> } = {};

		if (this.parameters.idDemandDH) {
			observables[`allMissionsAssignedOfModule`] = this.facade.missionService
				.postMissionsForceAffectationAndIdDemandDH(
					listMissionWithAssignedEmployee,
					this.selectedEmployee.id,
					this.parameters.idDemandDH
				)
				.pipe(
					catchError((error) => {
						console.error(
							`Error posting listMissionWithAssignedEmployee`,
							error
						);
						return of(null);
					})
				);
		} else {
			listMissionWithAssignedEmployee.forEach((mission, index) => {
				observables[`assignedMission_${index}`] = this.facade.missionService
					.postMissionWithAssignation(mission, mission.assignedEmployee.id)
					.pipe();
			});
		}

		listMissionWithoutAssignedEmployee.forEach((mission, index) => {
			if (this.parameters.idDemandDH) {
				observables[`unassignedMission_${index}`] = this.facade.missionService
					.postMissionWithIdDemandDH(mission, this.parameters.idDemandDH)
					.pipe(
						catchError((error) => {
							console.error(
								`Error posting unassigned mission ${index}:`,
								error
							);
							return of(null);
						})
					);
			} else {
				observables[`unassignedMission_${index}`] = this.facade.missionService
					.postMission(mission)
					.pipe(
						catchError((error) => {
							console.error(
								`Error posting unassigned mission ${index}:`,
								error
							);
							return of(null);
						})
					);
			}
		});

		forkJoin(observables).subscribe({
			next: (results) => {
				// `results` est un objet avec les mêmes clés que celles utilisées dans `observables`
				this.logger.log('All missions processed successfully', results);
			},
			error: (error) => {
				this.logger.error('An error occurred while processing missions', error);
				this.facade.toastService.createHttpErrorToast(
					error.error.response
						? error.error.response
						: 'Une erreur est survenue lors de la création de la mission',
					error.status
				);
				this.isValidateButtonClicked = false;
				this.closeModal();
			},
			complete: () => {
				this.logger.log('Mission processing completed');
				this.isValidateButtonClicked = false;
				this.closeModal();
			}
		});
	}

	prepareMissionList(): Mission[] {
		const listMission: Mission[] = [];
		const datesToProcess = this.form
			.get('prestations')
			.value.map((p) => p.date);

		datesToProcess.forEach((date, index) => {
			const prestationControl = this.prestations.controls[index];
			const intervention = new MissionRequest();
			intervention.readyTime = this.timeToNumber(
				prestationControl.get('readyTime').value
			);
			intervention.dueTime = this.timeToNumber(
				prestationControl.get('dueTime').value
			);
			//TODO: gérer les TW et la duration
			intervention.duration = intervention.dueTime - intervention.readyTime;
			intervention.date = new Date(
				date.getFullYear(),
				date.getMonth(),
				date.getDate()
			);
			if (this.facade.dataStorageService.isSESSAD() || this.isSAE) {
				intervention.missionPlace = prestationControl.get('missionPlace').value;
				//TODO: preparationTime
				// intervention.preparationTimePercentage = prestationControl.get(
				// 	'preparationTimePercentage'
				// ).value;
			}
			intervention.remote = prestationControl.get('isRemote').value;
			intervention.reminderStatus =
				this.form.get('remind').value === true ? 'ACTIVE' : 'INACTIVE';

			intervention.careSkills = prestationControl.get('competences').value;
			intervention.beneficiaire = this.selectedBeneficiaire;
			intervention.missionType = this.selectedMissionType;
			//TODO: careSpecialty
			intervention.careSpecialty = { id: 0, name: 'Sans' };
			intervention.notes = prestationControl.get('notes').value;

			intervention.centerDepartment = this.selectedCenterDepartment;
			//TODO: nombreIntervenant

			const mission = new Mission();
			mission.plannedStart = intervention.readyTime;
			mission.plannedEnd = intervention.dueTime;
			mission.missionRequest = intervention;
			if (this.isProjectManager || this.isProfessionnelSAE) {
				mission.planner = this.facade.dataStorageService.getUser().employee;
			}
			if (this.parameters.intervenantId && this.selectedEmployee) {
				mission.assignedEmployee = this.selectedEmployee;
			} else {
				mission.assignedEmployee = this.selectedEmployeesForMission[index];
			}

			listMission.push(mission);
		});
		return listMission;
	}

	timeToNumber(date: Date): number {
		return date.getHours() * 60 + date.getMinutes();
	}

	// shouldDisplayCompetences(index: number) {
	// 	const should =
	// 	prestation.controls[index].get('competences') &&
	// 	!isReunion;
	// }

	closeModal() {
		this.bsModalRef.hide();
		// this.router.navigate(['/gestion/formations/list']);
	}

	// Méthode pour mettre à jour la plage de dates formatée
	updateFormattedDateRange() {
		if (this.bsInlineRangeValue && this.bsInlineRangeValue.length === 2) {
			const startDate = this.datePipe.transform(
				this.bsInlineRangeValue[0],
				'dd/MM/yyyy'
			);
			const endDate = this.datePipe.transform(
				this.bsInlineRangeValue[1],
				'dd/MM/yyyy'
			);
			this.formattedDateRange = `Début : ${startDate} - Fin : ${endDate}`;
		}
	}

	getAccordeonPrestationTitle(index: number) {
		let returnText = `Prestation ${index + 1}`;
		const date = this.prestations.value[index].date;
		if (date) {
			returnText += ` - ${this.datePipe.transform(date, 'dd/MM/yyyy')}`;
		}
		const readyTime = this.prestations.value[index].readyTime as Date;
		const dueTime = this.prestations.value[index].dueTime as Date;
		if (date && readyTime && dueTime) {
			returnText += ` (${this.dateUtils.convertFromDateToMinuteString(
				readyTime
			)} - ${this.dateUtils.convertFromDateToMinuteString(dueTime)})`;
		}
		const assignedEmployee = this.selectedEmployeesForMission[index];
		if (assignedEmployee) {
			returnText += ` - ${assignedEmployee.firstName} ${assignedEmployee.lastName}`;
		}

		return returnText;
	}

	// Méthode appelée lorsque la plage de dates change
	onDateRangeChange(event: any) {
		this.bsInlineRangeValue = event;
		this.updateFormattedDateRange();
	}

	typeaheadSpecialityOnSelect(event: TypeaheadMatch, index: number): void {
		this.prestations
			.at(index)
			.patchValue({ specialty: event.item.name }, { onlySelf: true });
		this.selectedSpecialtiesForMission[index] = event.item as Specialite;
	}

	specialityKeyUp(e: any, index: number) {
		if (
			this.selectedSpecialtiesForMission[index] &&
			this.selectedSpecialtiesForMission[index].name !== e.value
		) {
			this.selectedSpecialtiesForMission[index] = null;
		}
	}

	getSpecialty(index: number): Specialite | null {
		return this.selectedSpecialtiesForMission?.[index] ?? null;
	}

	typeaheadCenterDepartmentOnSelect(event: TypeaheadMatch): void {
		this.selectedCenterDepartment = event.item as CenterDepartment;
	}

	centerDepartmentsKeyUp(e: any) {
		if (
			this.selectedCenterDepartment &&
			this.selectedCenterDepartment.name +
				' ' +
				this.selectedCenterDepartment.name !=
				e.value
		) {
			this.selectedCenterDepartment = null;
		}
	}

	typeaheadTypeFormationOnSelect(event: TypeaheadMatch): void {
		this.selectedMissionType = event.item as MissionType;
		this.selectCareSkillFromMissionTypeSAE(-1);

		if (this.selectedMissionType?.type === MISSION_TYPE_REUNION_TYPE) {
			this.isReunion = true;
			this.messageInviteIntervenantParticipant =
				'Entrez un participant à ajouter';
		} else {
			this.isReunion = false;
			this.messageInviteIntervenantParticipant =
				'Entrez un intervenant à ajouter';
		}

		if (this.selectedMissionType.type === MissionTypeName.REUNION) {
			this.selectedBeneficiaire = null;
		} else {
			this.numberOfIntervenantsSelected = 0;
		}
		this.selectedEmployeesForMission = [];

		this.maxIntervenantSelectableForMission =
			this.selectedMissionType.numberOfEmployee;
		this.checkValidityOfNumberOfEmployee();
	}

	typeFormationKeyUp(e: any) {
		if (this.selectedMissionType && this.selectedMissionType.type !== e.value) {
			this.selectedMissionType = null;
		}
	}

	selectCareSkillFromMissionTypeSAE(index: number) {
		if (this.facade.dataStorageService.isSAE()) {
			if (index === -1) {
				// Mettre à jour toutes les prestations
				this.prestations.controls.forEach((formGroup: FormGroup) => {
					const competencesControl = formGroup.get('competences');
					if (competencesControl) {
						this.updateCompetences(competencesControl);
					}
				});
			} else {
				// Mettre à jour une prestation spécifique
				const competencesControl = this.prestations
					.at(index)
					.get('competences');
				if (competencesControl) {
					this.updateCompetences(competencesControl);
				}
			}
		}
	}

	private updateCompetences(competencesControl: AbstractControl) {
		if (!(competencesControl instanceof FormArray)) {
			console.error('competencesControl is not a FormArray');
			return;
		}

		competencesControl.clear(); // Réinitialiser les compétences

		const competences: CareSkill[] = [];

		if (this.selectedMissionType?.type === MISSION_TYPE_QUALIFICATION_DEMAND) {
			competences.push({
				name: CompetencesElementaires.QUALIFICATION.name,
				id: CompetencesElementaires.QUALIFICATION.id
			});
		} else if (this.selectedMissionType?.type === MISSION_TYPE_PRESCRIPTION) {
			competences.push({
				name: CompetencesElementaires.PRESCRIPTION.name,
				id: CompetencesElementaires.PRESCRIPTION.id
			});
		} else {
			competences.push({
				name: CompetencesElementaires.TERRAIN.name,
				id: CompetencesElementaires.TERRAIN.id
			});
		}

		competences.forEach((comp) => {
			competencesControl.push(
				this.fb.group({
					name: [comp.name],
					id: [comp.id]
				})
			);
		});
	}

	checkValidityOfNumberOfEmployee() {
		// this.isNumberOfIntervenantInputValid = true;
		// // dans le cas d'une réunion, vérifier juste qu'on ait toujours au moins 1 intervenant
		// if (this.selectedMissionType.type === MissionTypeName.REUNION) {
		// 	if (this.formAjout.get('nombreIntervenants').value > 0) {
		// 		this.isNumberOfIntervenantSelectedValid = true;
		// 	} else {
		// 		this.isNumberOfIntervenantSelectedValid = false;
		// 	}
		// }
		// // Le nombre d'intervenant doit être positif et ne doit pas être supérieur au nombre max. d'intervenant
		// // pour le type de mission sélectionée
		// if (
		// 	this.formAjout.get('nombreIntervenants').value >= 0 &&
		// 	this.formAjout.get('nombreIntervenants').value <=
		// 		this.maxIntervenantSelectableForMission
		// ) {
		// 	this.isNumberOfIntervenantSelectedValid = true;
		// } else {
		// 	this.isNumberOfIntervenantSelectedValid = false;
		// }
	}

	typeaheadBeneficiaireOnSelect(event: TypeaheadMatch): void {
		this.selectedBeneficiaire = event.item.object as Beneficiaire;
		if (this.facade.dataStorageService.isSESSAD()) {
			// Seul cas où le bénéficiaire a une compétence
			this.selectedBeneficiaire.careSkills.forEach((c) =>
				this.prestations.controls.forEach((formGroup: FormGroup) => {
					const competencesControl = formGroup.get('competences');
					if (competencesControl) {
						const currentCompetences =
							(competencesControl.value as string[]) || [];
						const newCompetence = [c];
						const updatedCompetences = Array.from(
							new Set([...currentCompetences, ...newCompetence])
						);
						competencesControl.setValue(updatedCompetences);
					}
				})
			);
		}
		this.form.patchValue({ beneficiaire: event.item.name }, { onlySelf: true });
	}

	beneficiaireKeyUp(e: any) {
		if (
			this.selectedBeneficiaire &&
			this.selectedBeneficiaire.firstName +
				' ' +
				this.selectedBeneficiaire.lastName !==
				e.value
		) {
			this.selectedBeneficiaire = null;
		}
	}

	isBeneficiaireAddressEqualsToCenterAddress() {
		return (
			this.selectedBeneficiaire.address.label ===
			this.dataStorageService.getServiceCenter().address.label
		);
	}

	// si true : affiche dans le template la possibilité de cocher le domicile du bénéficiaire
	displayBeneficiaireLocation(index: number): boolean {
		return (
			!this.isReunion &&
			!!this.selectedBeneficiaire &&
			!this.prestations.controls[index].get('isRemote').value
		);
	}

	isAlertAddressBeneficiaireNeeded(index: number) {
		return (
			//this.form.get('nombreIntervenants').value === 1 &&
			this.prestations.controls[index].get('isMissionPlaceBeneficiaireAddress')
				.value &&
			this.selectedBeneficiaire &&
			(!(
				this.selectedBeneficiaire.address.longitude &&
				this.selectedBeneficiaire.address.latitude
			) ||
				this.isBeneficiaireAddressEqualsToCenterAddress())
		);
	}

	typeaheadMissionPlaceOnSelect(event: TypeaheadMatch, index: number): void {
		const selectedMissionPlace: MissionPlace = event.item;
		const missionPlaceControl =
			this.prestations.controls[index].get('missionPlace');
		const missionPlaceNameControl =
			this.prestations.controls[index].get('missionPlaceName');

		if (missionPlaceControl) {
			missionPlaceControl.setValue(selectedMissionPlace);
		}
		if (missionPlaceNameControl) {
			missionPlaceNameControl.setValue(selectedMissionPlace.nameDisplay);
		}
	}

	missionPlaceKeyUp(e: any, index: number) {
		const missionPlaceControl =
			this.prestations.controls[index].get('missionPlace');
		const missionPlaceNameControl =
			this.prestations.controls[index].get('missionPlaceName');

		if (missionPlaceControl && missionPlaceNameControl) {
			if (missionPlaceControl.value?.nameDisplay !== e.value) {
				missionPlaceControl.setValue(null);
				missionPlaceNameControl.setValue('');
			}
		}
	}

	getMissionLocation(index: number) {
		if (this.isSAE && this.selectedBeneficiaire) {
			return this.prestations.controls[index].get(
				'isMissionPlaceBeneficiaireAddress'
			).value
				? this.selectedBeneficiaire.address
				: this.prestations.controls[index].get('missionPlace').value?.address;
		}
	}

	getMissionPlaceNameDisplay(index: number): string {
		const missionPlace = this.prestations.controls[index].get('missionPlace')
			?.value as MissionPlace;
		return missionPlace?.nameDisplay || '';
	}

	getMissionPlaceNameControl(index: number) {
		return this.prestations.at(index).get('missionPlaceName') as FormControl;
	}

	resetMissionPlace(index: number) {
		const isMissionPlaceBeneficiaireAddress = this.prestations.controls[
			index
		].get('isMissionPlaceBeneficiaireAddress').value;
		const isRemote = this.prestations.controls[index].get('isRemote').value;

		if (isMissionPlaceBeneficiaireAddress || isRemote) {
			// Réinitialiser les contrôles missionPlace et missionPlaceName
			this.prestations.controls[index].patchValue(
				{ missionPlace: null, missionPlaceName: '' },
				{ onlySelf: true }
			);

			// Réinitialiser isMissionPlaceBeneficiaireAddress si isRemote est vrai
			if (isRemote) {
				this.prestations.controls[index].patchValue(
					{ isMissionPlaceBeneficiaireAddress: false },
					{ onlySelf: true }
				);
			}
		}
	}

	updatePrestationCount(event: Event) {
		const inputElement = event.target as HTMLInputElement;
		const value = parseInt(inputElement.value, 10);
		if (!isNaN(value)) {
			this.numberOfPrestations = value;
			this.setPrestations(value);
		}
	}

	setPrestations(count: number) {
		const prestationsArray = this.form.get('prestations') as FormArray;

		// Si le nombre de prestations diminue, supprimer les éléments excédentaires
		if (count < prestationsArray.length) {
			while (prestationsArray.length > count) {
				prestationsArray.removeAt(prestationsArray.length - 1);
			}
		}
		// Si le nombre de prestations augmente, ajouter les nouveaux éléments
		else if (count > prestationsArray.length) {
			for (let i = prestationsArray.length; i < count; i++) {
				prestationsArray.push(
					this.fb.group(
						{
							date: [null, Validators.required],
							readyTime: new FormControl(this.readyTimeDate, [
								Validators.required,
								workingTimeValidator(
									this.MIN_WORKING_HOUR,
									this.MAX_WORKING_HOUR
								)
							]),
							dueTime: new FormControl(this.dueTimeDate, [
								Validators.required,
								workingTimeValidator(
									this.MIN_WORKING_HOUR,
									this.MAX_WORKING_HOUR
								)
							]),
							missionPlace: new FormControl(
								null,
								this.createMissionPlaceValidator(i)
							),
							missionPlaceName: new FormControl(''), // Champ pour le nom affiché
							isMissionPlaceBeneficiaireAddress: new FormControl(false),
							isRemote: new FormControl(false),
							competences: this.fb.array([] as CareSkill[]),
							specialty: [''],
							notes: new FormControl('', Validators.maxLength(1023))
						},
						{
							validators: [durationValidator(this.MAX_DURATION)]
						}
					)
				);
				this.selectCareSkillFromMissionTypeSAE(i);
			}
		}
	}

	getCareSkills(index: number): CareSkill[] {
		const competencesControl = this.prestations.at(index).get('competences');
		const competences = competencesControl
			? (competencesControl.value as CareSkill[])
			: [];
		return competences;
	}

	isCompetenceCheck(comp: CareSkill, index: number): boolean {
		const competences = this.getCareSkills(index);
		return competences.some((currComp) => currComp.id === comp.id);
	}

	isCompetencesElementaires(competence: CareSkill): boolean {
		return !!CompetencesElementaires[competence.name];
	}

	updateSelectedCompetence(e: any, comp: CareSkill, index: number) {
		const prestationsControl = this.prestations
			.at(index)
			.get('competences') as FormArray;
		let competences = prestationsControl
			? (prestationsControl.value as CareSkill[])
			: [];

		if (e.target.checked) {
			if (!competences.some((z: CareSkill) => z.id === comp.id)) {
				competences.push(comp);
				this.updateFormArray(prestationsControl, competences);
			}
		} else {
			if (competences.some((z: CareSkill) => z.id === comp.id)) {
				competences = competences.filter((z: CareSkill) => z.id !== comp.id);
				this.updateFormArray(prestationsControl, competences);
			}
		}
	}

	selectEmployee(employee: Employee, index: number) {
		this.selectedEmployeesForMission[index] = employee;
	}

	private updateFormArray(formArray: FormArray, competences: CareSkill[]) {
		formArray.clear(); // Réinitialiser le FormArray

		competences.forEach((comp) => {
			formArray.push(
				this.fb.group({
					name: [comp.name],
					id: [comp.id]
				})
			);
		});
	}

	isDateInvalid(i: number) {
		const isDateInvalid =
			this.prestations.controls[i].get('date').invalid &&
			(this.prestations.controls[i].get('date').dirty ||
				this.prestations.controls[i].get('date').touched ||
				this.prestations.controls[i].get('date').errors?.required);
		return isDateInvalid;
	}

	get beneficiaire() {
		return this.form.get('beneficiaire');
	}

	get prestations() {
		// return <FormArray<FormGroup>>this.form.controls['prestations'];
		return this.form.get('prestations') as FormArray;
	}

	get remind() {
		return this.form.get('remind').value;
	}

	get missionType() {
		return this.form.get('missionType');
	}

	get centerDepartment() {
		return this.form.get('centerDepartment');
	}

	/**
	 * Validator vérifiant si la mission place écrite par l'utilisateur est correcte
	 * Si oui => on sélectionne automatiquement la mission place de la liste pour éviter que l'utilisateur ne la sélectionne après l'avoir tapé
	 * Si non => input invalid, on le fait savoir à l'utilisateur
	 * @returns null si pas d'erreur, l' {erreur:true} sinon
	 */
	createMissionPlaceValidator(index: number): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			// value = ce qui est taper au clavier par l'utilisateur
			const value = control.value?.nameDisplay;

			if (!value) {
				return null;
			}

			const missionPlaceFoundFromUserInput = this.listMissionPlace.find(
				(missionPlace) => missionPlace.nameDisplay === value
			);

			let missionPlaceValid = true;
			if (
				!this.prestations.controls[index].get(
					'isMissionPlaceBeneficiaireAddress'
				).value
			) {
				missionPlaceValid = missionPlaceFoundFromUserInput !== undefined;
			}

			// on sélectionne automatiquement la mission place de la liste
			if (missionPlaceValid) {
				// this.selectedMissionPlace = missionPlaceFoundFromUserInput;
			}

			// si l'user a taper n'importe quoi, on lui affiche un message d'erreur
			return !missionPlaceValid ? { missionPlace: true } : null;
		};
	}

	isDateOutOfRange(index: number): boolean {
		const dateControl = this.prestations.controls[index].get('date');
		const selectedDate = dateControl?.value;
		if (!selectedDate || !this.bsInlineRangeValue) return false;

		const date = new Date(selectedDate);
		const start = new Date(this.bsInlineRangeValue[0]);
		const end = new Date(this.bsInlineRangeValue[1]);
		return date < start || date > end;
	}

	getDateCustomClasses() {
		if (!this.bsInlineRangeValue) {
			return [];
		}
		const [start, end] = this.bsInlineRangeValue;
		const dates = this.getDatesBetween(new Date(start), new Date(end));

		// On construit une liste d'objets { date: Date, classes: 'in-range-date' }
		return dates.map((d) => ({
			date: d,
			classes: ['in-range-date']
		}));
	}

	getDatesBetween(start: Date, end: Date): Date[] {
		const dates = [];
		let current = new Date(start);
		while (current <= end) {
			dates.push(new Date(current));
			current.setDate(current.getDate() + 1);
		}
		return dates;
	}

	updateBsConfig(): void {
		this.bsConfig = {
			...this.bsConfig, // on garde les autres propriétés existantes
			dateCustomClasses: this.getDateCustomClasses() // on met à jour les classes avec la nouvelle période
			// minDate: this.bsInlineRangeValue ? this.bsInlineRangeValue[0] : undefined,
			// maxDate: this.bsInlineRangeValue ? this.bsInlineRangeValue[1] : undefined
		};
	}
}
